import type { ThemeConfig } from 'antd';
import type { LooseObjectType, BrandCodeType } from 'utils/globalTypes';
import { BRAND_CODES } from 'brand-config';
import { defaultConfig, defaultVariables } from 'theme/default';
import { privacyConfig, privacyVariables } from 'theme/privacy';
import { psmsConfig, psmsVariables } from 'theme/psms';
import { mgsafeConfig, mgsafeVariables } from 'theme/mgsafe';
import { dshopConfig, dshopVariables } from 'theme/dshop';
import { dsafeConfig, dsafeVariables } from 'theme/dsafe';
import { partyhatConfig, partyhatVariables } from 'theme/partyhat';
import { protectivConfig, protectivVariables } from 'theme/protectiv';
import { phSafeConfig, phSafeVariables } from 'theme/phsafe';
import { iddefenseConfig, iddefenseVariables } from 'theme/iddefense';
import { boapaConfig, boapaVariables } from 'theme/boapa';
import { ultraavConfig, ultraavVariables } from 'theme/ultraav';
import { totalavConfig, totalavVariables } from 'theme/totalav';
import { enguardConfig, enguardVariables } from 'theme/enguard';
import { hmtgConfig, hmtgVariables } from 'theme/hometitle';
import { afs2Config, afs2Variables } from 'theme/afs2';
import { mshieldConfig, mshieldVariables } from 'theme/mshield';
import { dminorConfig, dminorVariables } from 'theme/dminor';
import { discoverConfig, discoverVariables } from 'theme/discover';
import { comericaConfig, comericaVariables } from 'theme/comerica';
import { bofwestConfig, bofwestVariables } from 'theme/bofwest';
import { creditmonConfig, creditmonVariables } from 'theme/creditmon';
import { barclaysConfig, barclaysVariables } from 'theme/barclays';
import { idguardConfig, idguardVariables } from 'theme/idguard';
import { creditnotifyConfig, creditnotifyVariables } from 'theme/creditnotify';
import { aolidgConfig, aolidgVariables } from 'theme/aolidg';
import { anpacConfig, anpacVariables } from 'theme/anpac';

type BrandThemeConfig = {
  config: ThemeConfig;
  variables: LooseObjectType;
};

export type BrandThemeConfigType = Record<
  BrandCodeType | 'default',
  BrandThemeConfig
>;

const BRAND_THEME_CONFIG: BrandThemeConfigType = {
  [BRAND_CODES.privacyShield]: {
    config: privacyConfig,
    variables: privacyVariables,
  },
  [BRAND_CODES.privacyMedicalShield]: {
    config: psmsConfig,
    variables: psmsVariables,
  },
  [BRAND_CODES.missGroupSafe]: {
    config: mgsafeConfig,
    variables: mgsafeVariables,
  },
  [BRAND_CODES.domeneShop]: {
    config: dshopConfig,
    variables: dshopVariables,
  },
  [BRAND_CODES.domainkeskusSafe]: {
    config: dsafeConfig,
    variables: dsafeVariables,
  },
  [BRAND_CODES.partyhat]: {
    config: partyhatConfig,
    variables: partyhatVariables,
  },
  [BRAND_CODES.protectIV]: {
    config: protectivConfig,
    variables: protectivVariables,
  },
  [BRAND_CODES.phSafe]: {
    config: phSafeConfig,
    variables: phSafeVariables,
  },
  [BRAND_CODES.identityDefense]: {
    config: iddefenseConfig,
    variables: iddefenseVariables,
  },
  [BRAND_CODES.myPrivacyAssist]: {
    config: boapaConfig,
    variables: boapaVariables,
  },
  [BRAND_CODES.minorDefense]: {
    config: dminorConfig,
    variables: dminorVariables,
  },
  [BRAND_CODES.medicalShield]: {
    config: mshieldConfig,
    variables: mshieldVariables,
  },
  [BRAND_CODES.financialShield]: {
    config: afs2Config,
    variables: afs2Variables,
  },
  [BRAND_CODES.homeTitleGuardian]: {
    config: hmtgConfig,
    variables: hmtgVariables,
  },
  [BRAND_CODES.enguard]: {
    config: enguardConfig,
    variables: enguardVariables,
  },
  [BRAND_CODES.totalAv]: {
    config: totalavConfig,
    variables: totalavVariables,
  },
  [BRAND_CODES.ultraAv]: {
    config: ultraavConfig,
    variables: ultraavVariables,
  },
  [BRAND_CODES.anpac]: {
    config: anpacConfig,
    variables: anpacVariables,
  },
  [BRAND_CODES.aolidg]: {
    config: aolidgConfig,
    variables: aolidgVariables,
  },
  [BRAND_CODES.creditnotify]: {
    config: creditnotifyConfig,
    variables: creditnotifyVariables,
  },
  [BRAND_CODES.idguard]: {
    config: idguardConfig,
    variables: idguardVariables,
  },
  [BRAND_CODES.barclays]: {
    config: barclaysConfig,
    variables: barclaysVariables,
  },
  [BRAND_CODES.creditmon]: {
    config: creditmonConfig,
    variables: creditmonVariables,
  },
  [BRAND_CODES.bofwest]: {
    config: bofwestConfig,
    variables: bofwestVariables,
  },
  [BRAND_CODES.comerica]: {
    config: comericaConfig,
    variables: comericaVariables,
  },
  [BRAND_CODES.discover]: {
    config: discoverConfig,
    variables: discoverVariables,
  },
  default: {
    config: defaultConfig,
    variables: defaultVariables,
  },
};

export default BRAND_THEME_CONFIG;
